export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-logo">⚡ BulletAI</span>
        <p className="footer-text">
          Built with React + OpenAI API &mdash; Open source &amp; privacy-first.
          Your API key never leaves your browser.
        </p>
        <div className="footer-links">
          <a href="https://github.com/Nikita-Parjane27" target="_blank" rel="noreferrer">GitHub</a>
          <a href="https://platform.openai.com/api-keys" target="_blank" rel="noreferrer">Get API Key</a>
        </div>
      </div>
    </footer>
  );
}
